// assets
import { IconTicket, IconBrandDropbox } from '@tabler/icons-react';

// constant
const icons = {
    IconTicket,
    IconBrandDropbox
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const exporting = {
    id: 'export-routes',
    title: 'Reportes',
    type: 'group',
    children: [
        {
            id: 'tickets',
            title: 'Solicitudes de soporte',
            type: 'item',
            url: '/export/tickets',
            icon: icons.IconTicket,
            external: false,
            breadcrumbs: false,
            target: false
        },
        {
            id: 'production',
            title: 'Producción',
            type: 'item',
            url: '/export/production',
            icon: icons.IconBrandDropbox,
            external: false,
            breadcrumbs: false,
            target: false
        }
    ]
};

export default exporting;
